export default __webpack_public_path__ + "static/media/pediatrics.96804bfa.svg";